import {Component, Input} from '@angular/core';

@Component({
  selector: 'tech-core-quiz-scoreboard-card',
  standalone: false,
  templateUrl: './scoreboard-card.component.html',
  styleUrl: './scoreboard-card.component.scss'
})
export class ScoreboardCardComponent {

  @Input()
  active: boolean = true;

  @Input()
  rank: string = "";

  @Input()
  userName: string = "";

  @Input()
  score: string = "";

}
